// extracted by mini-css-extract-plugin
module.exports = {"chartlegend":"colorLegend_chartlegend__110zi","pillcontainer":"colorLegend_pillcontainer__B2XTy","pill":"colorLegend_pill__JcAUC","pilllabel":"colorLegend_pilllabel__2X95y"};